
import { Component, defineComponent, PropType } from "vue";

type CardType = "THOUGHT" | "IDEA" | "BUG";
interface Card {
  type: CardType;
  title: string;
  icon: Component;
  alt: string;
  description: string;
}

export default defineComponent({
  name: "FeedbackSelection",
  props: {
    options: {
      type: Object as PropType<Card[]>,
      required: true,
    },
  },
  methods: {
    handleClick(card: CardType) {
      this.$emit("onCardSelection", card);
    },
  },
  emits: ["onCardSelection"],
});
